export function stringSize(str: string): number {
  return new Blob([str]).size;
}

export function localStorageSize(): Record<string, number> {
  const total: Record<string, number> = {};
  for (const key in localStorage) {
    if (Object.prototype.hasOwnProperty.call(localStorage, key)) {
      const value = localStorage.getItem(key);
      if (value) {
        total[key] = stringSize(value);
      }
    }
  }
  total["SUMME"] = Object.values(total).reduce((x, y) => x + y, 0);
  return total;
}
